import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// userInfo
const userInfo = {
  namespaced: true,
  state: {
    name: 'Guest',
  },
  mutations: {
    update (state, name) {
      state.name = name
    },
  },
}

export default new Vuex.Store({
  state: {
    isLoading: false,
    payStatus: {
      READY: { desc: '待支付' },
      SUCCESS: { desc: '支付成功' },
      FAILED: { desc: '支付失敗' },
      REFOUND: { desc: '退还' },
    },
  },
  mutations: {
    showLoading (state, payload) {
      state.isLoading = payload.isLoading
    },
  },
  modules: {
    userInfo: userInfo,
  },
})
